export const API_HOST = "https://nuerburgring.de"
